import React from "react";
import { Textarea, Typography } from "@material-tailwind/react";
import { t } from "i18next";

interface MachineNotesProps {
  notes: string;
  onChange: (notes: string) => void;
}

/**
 * Composant pour l'édition des notes d'une machine
 * Affiché uniquement en mode édition
 */
export default function MachineNotes({ notes, onChange }: MachineNotesProps) {
  return (
    <div className="p-4 bg-blue-50 border-b border-blue-gray-100">
      <Typography variant="small" className="mb-2 font-medium">
        {t("workorder:machines:notes")}
      </Typography>
      <Textarea
        value={notes}
        onChange={(e) => onChange(e.target.value)}
        className="bg-white"
        resize={true}
        rows={3}
      />
    </div>
  );
} 